import React from "react";
import { APPLICATION_STATUS_CONFIG } from "./StatusControl/configs/applicationConfig";

interface AppCountBadgeProps {
  count: number;
  mostAdvancedStatus?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const AppCountBadge: React.FC<AppCountBadgeProps> = ({
  count,
  mostAdvancedStatus,
  onClick,
}) => {
  if (count <= 0) return null;

  const config = mostAdvancedStatus
    ? APPLICATION_STATUS_CONFIG[mostAdvancedStatus]
    : undefined;

  const bgColor = config?.bgColor || "#f3f4f6";
  const color = config?.color || "#374151";
  const borderColor = config?.color || "#d1d5db";

  const Tag = onClick ? "button" : "span";

  return (
    <Tag
      type={onClick ? "button" : undefined}
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "2px 8px",
        borderRadius: "9999px",
        fontSize: "11px",
        fontWeight: 500,
        backgroundColor: bgColor,
        color: color,
        border: `1px solid ${borderColor}`,
        cursor: onClick ? "pointer" : undefined,
      }}
    >
      {count} app{count === 1 ? "" : "s"}
      {mostAdvancedStatus && config && (
        <>
          {" · "}
          {config.label}
        </>
      )}
    </Tag>
  );
};

export default AppCountBadge;
